import dynamic from "next/dynamic";

const HtmlPack = dynamic(() => import("@/components/organisms/html-pack").then((mod) => mod.HtmlPack));

/**
 * An HTML pack as a whole page body.
 */
export function NodeHtmlPack({node, additionalContent, ...props}) {
  const pack = additionalContent?.htmlPack;

  if (!pack?.html) return null;

  return <HtmlPack pack={pack} {...props}/>;
}
